import { EthereumPlaceholderLogo } from "./staking-styled-components";

// MOCK DATA
export const mockStakingRewards = [1, 1, 1];
export const mockCoinsAvailableForStaking = ["Solana", "Ethereum", "Cardano"];
export const mockHistoryTableData = ["Solana", "Ethereum", "Cardano"];
export const mockCoins = [
  {
    label: "Ethereum",
    icon: <EthereumPlaceholderLogo />,
  },
  {
    label: "Solana",
    icon: <EthereumPlaceholderLogo />,
  },
  {
    label: "Cardano",
    icon: <EthereumPlaceholderLogo />,
  },
];
